import script from "./RedesignFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./RedesignFooter.vue?vue&type=script&setup=true&lang=js"

import "./RedesignFooter.vue?vue&type=style&index=0&id=1390edc2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1390edc2"]])

export default __exports__